/** @jsxImportSource @emotion/react */

import { Field } from "formik";
import MuiTextField from "@mui/material/TextField";

import css from "../form.module.css";

const FormikTextField = ({
	label,
	labelShrink = false,
	type = "text",
	name,
  halfWidth,
  ...rest
}) => {
  return (
    <Field name={name}>
      {({ field, meta }) => (
        <MuiTextField
          {...field}
          type={type}
          label={label}
          InputLabelProps={{ shrink: labelShrink }}
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
          {...rest}
          css={emotion.field(halfWidth)}
          className={css.field}
        />
      )}
    </Field>
  )
};

const emotion = {
	field: (isHalfWidth) => ({
    flex: isHalfWidth ? '0 1 48.5%' : null,
    width: isHalfWidth ? 'auto' : '100%',
	}),
};

export default FormikTextField;
